export default __webpack_public_path__ + "static/media/user.804a1a34.svg";